import { render, staticRenderFns } from "./PanelInfo.vue?vue&type=template&id=11d649d1&"
import script from "./PanelInfo.vue?vue&type=script&lang=js&"
export * from "./PanelInfo.vue?vue&type=script&lang=js&"
import style0 from "./PanelInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports